import { Injectable } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { environment } from "../../config/environment";
import { firstValueFrom } from "rxjs";
import { BqaJobSyncMetadata } from "./data-sync-metadata.service";

@Injectable({
  providedIn: "root"
})
export class DataSyncMetadataApiService {

  constructor(private http: HttpClient) { }

  updateMetaData(bqaSyncMetadata: Record<string, BqaJobSyncMetadata>): Promise<Record<string, BqaJobSyncMetadata>> {
    const url = `${environment.backend.apiBaseURL}/api/job/UpdateSyncMetadata`;
    return firstValueFrom(this.http.post<Record<string, BqaJobSyncMetadata>>(url, bqaSyncMetadata));
  }

}